/**
 * The Pages list "Type" cell: marks the seeded Information-Hub pages apart from TLC's own
 * pages, so the two aren't indistinguishable in the manager. A system page's address is
 * fixed and it can't be deleted (hence the lock); a normal page is fully editable.
 *
 * Takes the row's `system` boolean (column value), like the other crud cell formatters,
 * and returns markup painted through [innerHTML] - the content is static, so no escaping.
 */
export function pageTypeBadge(value: unknown): string {
    return true === value
        ? '<span class="badge rounded-pill bg-primary-subtle text-primary-emphasis border border-primary-subtle">' +
              '<i class="fa fa-lock me-1" aria-hidden="true"></i>Info page</span>'
        : '<span class="badge rounded-pill bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle">Page</span>';
}
